<template>
	<div class="profile profile-Client">
		<div class="vx-row">
			<div class="vx-col lg:w-1/4 w-full mb-10">
				<vx-card>
					<div class="flex justify-between items-center box-top">
						<div class="des">
							<b>{{countTask.count}}</b>
							<p>{{ $t('totalOrdersCount') }}</p>
						</div>
						<div class="icon">
							<feather-icon icon="FileTextIcon"></feather-icon>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="vx-col lg:w-1/4 w-full mb-10">
				<vx-card>
					<div class="flex justify-between items-center box-top">
						<div class="des">
							<b>{{countTaskActive.count}}</b>
							<p>{{ $t('activatedOrder') }}</p>
						</div>
						<div class="icon">
							<feather-icon icon="FilePlusIcon"></feather-icon>
						</div>
					</div>
				</vx-card>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col lg:w-1/2 w-full">
				<vx-card>
					<h2><b>{{ $t('profile') }}</b></h2>
					<table class="p-0">
						<tbody>
						<tr>
							<td class="pr-4 sm:pr-10">{{ $t('clientsEmail') }}</td>
							<td>{{user.email}}</td>
						</tr>
						<tr>
							<td class="pr-4 sm:pr-10">{{ $t('personName') }}</td>
							<td>{{user.first_name}} {{user.last_name}}</td>
						</tr>
						<tr>
							<td class="pr-4 sm:pr-10">{{ $t('sex') }}</td>
							<td>{{ $getDeep(user.gender, genders) }}</td>
						</tr>
						<tr>
							<td class="pr-4 sm:pr-10">{{ $t('phone') }}</td>
							<td>{{  user.phone }}</td>
						</tr>
						<tr>
							<td class="pr-4 sm:pr-10">{{ $t('site') }}</td>
							<td>{{  user.website }}</td>
						</tr>
						<tr v-if="user.other_websites && user.other_websites.length">
							<td class="pr-4 sm:pr-10">{{ $t('otherProfiles') }}</td>
							<td>
                <router-link
                  v-for="(site, index) in user.other_websites"
                  :key="site.id"
                  :to="`/clientM/${site.client_id}`"
                >
                  {{ site.name }}{{ addComa(user.other_websites, index) }}
                </router-link>
              </td>
						</tr>
						<tr>
							<td class="pr-4 sm:pr-10">{{ $t('additionalEmail') }}</td>
							<td>{{user.email_secondary}}</td>
						</tr>
						</tbody>
					</table>
					<div class="bottom">
            <div
              class="flex justify-center chat"
              @click="openChat()"
            >
              <vs-custom-button
                size="small"
                color="#626262"
                type="flat"
                icon-pack="feather"
                icon="edit"
              >
                <feather-icon icon="MessageSquareIcon"></feather-icon>
              </vs-custom-button>
            </div>
						<router-link :to="'/clientM/'+$route.params.id+'/edit'">
							<vs-button>{{ $t('edit') }}</vs-button>
						</router-link>
					</div>
				</vx-card>
			</div>
			<div v-if="user.id" class="vx-col max-w-full w-full mt-6">
				<ClientOrdersTable
          :clientId="user.id"
          ref="clientsTable"
        />
			</div>
		</div>
	</div>
</template>

<script>
import ClientOrdersTable from "@/components/ClientOrdersTable/ClientOrdersTable";
import vSelect from 'vue-select';
import notifier from "@/mixins/notifier";

export default {
	mixins: [notifier],
	components: {
		ClientOrdersTable,
		'v-select': vSelect,
	},
	name: "Client",
	data() {
		return {
			managers: [],
			countTask: '',
			countTaskActive: '',
			income: '',
			user: {},
			select1: '',

			popupActive: false,
			val: '',
			description: '',
			manager: '',
			countries: [],
			genders: [],

		}
	},
	methods: {
    openChat() {
      const id = this.$route.params.id
      if (!id) return
      try {
        this.$store.dispatch('getMessages',{userId: id});
      } catch (e) {
        this.notifyError(e.message);
      }
    },
    addComa(arr, index) {
      if (arr && arr.length > 1 && arr.length !== index + 1) return ', '
      return ''
    },
		async acceptChangeManager() {
			try {

				this.$http.post('/client/profile/request-manager-change',this.$formData({message: this.description}))
				this.description = '';

				this.notifySuccess(this.$t('changingManagerRequestIsSent'));
				this.popupActive = false;

			} catch (e) {
				this.notifyError(e.message);
				this.popupActive = false;
			}
		},
    async getUserData(id) {
      const requests = [
        async () => {
            this.countTask = (await this.$http.get('/manager/client/get-orders-count/'+id)).data.data
        },
        async () => {
            this.countTaskActive = (await this.$http.get('/manager/client/get-orders-active-count/'+id)).data.data
        },
        async () => {
            this.income = (await this.$http.get('/manager/client/get-money-spent/'+id)).data.data
        },
        async () => {
            this.user = (await this.$http.get('/manager/client/view/'+id)).data.data
        },
      ]

      await Promise.all(requests.map(item => item()))
    },
	},
	async created() {
    const routeId = +this.$route.params.id
		this.countries = (await this.$http.get('/settings/get-countries')).data.data
		this.genders = (await this.$http.get('/settings/get-genders')).data.data
		// this.countTask = (await this.$http.get('/manager/client/get-orders-count/'+this.$route.params.id)).data.data
		// this.countTaskActive = (await this.$http.get('/manager/client/get-orders-active-count/'+this.$route.params.id)).data.data
		// this.income = (await this.$http.get('/manager/client/get-money-spent/'+this.$route.params.id)).data.data
		// this.user = (await this.$http.get('/manager/client/view/'+this.$route.params.id)).data.data

    await this.getUserData(routeId)

		// this.managers = (await this.$http.get('/admin/manager')).data.data;

		// this.manager = (await this.$http.get('/client/profile/get-manager')).data.data
	},
  async beforeRouteUpdate (to, from, next) {
    next();
    await this.getUserData(to.params.id)
    this.$refs.clientsTable.filter()
  }
}
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables";
.vx-card__collapsible-content{
	height: 100%;
}
.vx-card__body{
	height: 100%;
	box-sizing: border-box;
}

.profile {

	.box-top{
		b{
			font-size: 18px;
		}
	}
	.icon{
		display: flex;
		align-items: center;
	}
	.feather-icon svg{
		width: 32px;
		height: 32px;
	}
	h2 {
		font-size: 18px;
		color: #626262;
		margin-bottom: 15px;
	}

	.vx-card {
		height: 100%;
	}

	table {
		margin-bottom: 20px;
		padding-left: 15px;

		tr {

			td {
				padding-bottom: 7px;

				&:first-child {
					font-weight: 600;
				}
			}

		}
	}

	.privatManager {
		.photo {
			width: 150px;
			height: 150px;
			border-radius: 10px;
			overflow: hidden;
			margin: 15px 15px;


			img {
				max-width: 100%;
			}
		}
	}

	.box {
		display: flex;
		font-size: 25px;
		align-items: center;
		margin-bottom: 22px;
	}

	.bottom {
		display: flex;
		justify-content: flex-end;
    
    .chat {
      margin-right: 15px;
      .vs-button {
        padding: 1px 10px 1px 6px;
        width: 46px;
        &-text {
          display: flex;
          .feather-icon {
            width: 26px;
            height: 26px;
          }
        }
      }
    }
	}

	&-Client {
		.vx-card {
			padding-right: 0 !important;
		}
	}
}

//.vs-popup {
//	max-width: 400px !important;
//
//	.vs-textarea {
//		height: 100px;
//	}
//
//	&--title {
//		h3 {
//			color: $warning;
//		}
//	}
//
//	p {
//		padding: 1rem;
//	}
//
//	&--button {
//		display: flex;
//		justify-content: flex-end;
//		border-top: 1px solid #e4e4e4;
//		padding: 1rem;
//		padding-bottom: 0.5rem;
//	}
//}

</style>
